import React from "react";
import PropTypes from "prop-types";

/**
 * Ingredient entry (for mash fermentables, yeast, etc.)
 */
const IngredientEntry = ({ ingredient }) => {
  const icon =
    ingredient.type === "YEAST"
      ? "🧫"
      : ingredient.type === "HOP"
        ? "🌿"
        : ingredient.type === "ADJ"
          ? "📦"
          : "🌾";

  return (
    <div className="brew-timeline__ingredient">
      <span className="brew-timeline__ingredient-icon">{icon}</span>
      <span>
        {ingredient.name} — {ingredient.amount}
      </span>
    </div>
  );
};

IngredientEntry.propTypes = {
  ingredient: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

export default IngredientEntry;
